import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface UploadGateProps {
  allowed: boolean;
  reasonKey?: string;
  children: (props: { disabled: boolean }) => ReactNode;
}

export function UploadGate({ allowed, reasonKey, children }: UploadGateProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      {!allowed ? (
        <div className="rounded-2xl border border-ai-warning/40 bg-ai-surface-elevated/70 px-4 py-3 text-sm text-ai-warning" role="alert">
          {t(reasonKey ?? 'memberPage.uploadGate.defaultMessage')}
        </div>
      ) : null}
      {children({ disabled: !allowed })}
    </div>
  );
}
